export default class VoyageArrivalWindowCreateData {
    constructor(earliestEta, latestEta, enforce) {
        this.earliestEta = earliestEta
        this.latestEta = latestEta
        this.enforce = enforce
    }
}